// Public UptimeRobot status page for RestoreAI services.
export const STATUS_PAGE_URL = "https://stats.uptimerobot.com/4zjHS7cxJD";
